import React from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'


const defaultstyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
const SuccessAndErrorModal = ({ handleClose, open, title, modalStyle = defaultstyle, isError = false }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalStyle}
        >
            <Box className={isError ? 'errorModal' : 'SuccessfullModal'}>
                <Typography className="title" variant="h6" component="h2">
                    {title}
                </Typography>
                <Button className='button' autoFocus={true} onClick={handleClose}>
                    ok
                </Button>
            </Box>
        </Modal>
    )
}

export default SuccessAndErrorModal